import { call, put, takeLatest } from "redux-saga/effects";
import Swal from "sweetalert2";
import {
    FETCH_COMPETENCES_GENERIQUES_REQUEST,
    fetchCompetencesGeneriquesSuccess,
    fetchCompetencesGeneriquesFail,
    CREATE_COMPETENCE_GENERIQUE_REQUEST,
    createCompetenceGeneriqueSuccess,
    createCompetenceGeneriqueFail,
    UPDATE_COMPETENCE_GENERIQUE_REQUEST,
    updateCompetenceGeneriqueSuccess,
    updateCompetenceGeneriqueFail,
    DELETE_COMPETENCE_GENERIQUE_REQUEST,
    deleteCompetenceGeneriqueSuccess,
    deleteCompetenceGeneriqueFail,
    setCompetencesGeneriquesLoading,
} from "../actions/competencesGeneriquesActions";
import { API_BASE_URL, getRequest, postRequest, putRequest, deleteRequest } from "../../../api";

const getUid = () => sessionStorage.getItem("uid");
const getToken = () => sessionStorage.getItem("token");

export function* fetchCompetencesGeneriquesSaga() {
    const url = `${API_BASE_URL}/api/competences-generiques`;
    const uid = getUid();
    const token = getToken();

    yield put(setCompetencesGeneriquesLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchCompetencesGeneriquesSuccess(resp.data));
    } catch (e) {
        yield put(fetchCompetencesGeneriquesFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setCompetencesGeneriquesLoading(false));
    }
}

export function* createCompetenceGeneriqueSaga(action) {
    const url = `${API_BASE_URL}/api/competences-generiques`;
    const uid = getUid();
    const token = getToken();

    yield put(setCompetencesGeneriquesLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            data: action.payload,
            uid,
            token,
        });
        yield put(createCompetenceGeneriqueSuccess(resp.data));
        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Compétence générique ajoutée",
            timer: 1400,
            showConfirmButton: false,
        });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur ajout compétence";
        yield put(createCompetenceGeneriqueFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setCompetencesGeneriquesLoading(false));
    }
}

export function* updateCompetenceGeneriqueSaga(action) {
    const { id, payload } = action.payload;
    const url = `${API_BASE_URL}/api/competences-generiques/${id}`;
    const uid = getUid();
    const token = getToken();

    yield put(setCompetencesGeneriquesLoading(true));
    try {
        const resp = yield call(putRequest, {
            url,
            data: payload,
            uid,
            token,
        });
        yield put(updateCompetenceGeneriqueSuccess(resp.data));
        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Compétence générique modifiée",
            timer: 1400,
            showConfirmButton: false,
        });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur modification compétence";
        yield put(updateCompetenceGeneriqueFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setCompetencesGeneriquesLoading(false));
    }
}

export function* deleteCompetenceGeneriqueSaga(action) {
    const { id } = action.payload;
    const url = `${API_BASE_URL}/api/competences-generiques/${id}`;
    const uid = getUid();
    const token = getToken();

    yield put(setCompetencesGeneriquesLoading(true));
    try {
        yield call(deleteRequest, { url, uid, token });
        yield put(deleteCompetenceGeneriqueSuccess(id));
        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Compétence générique supprimée",
            timer: 1400,
            showConfirmButton: false,
        });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur suppression compétence";
        yield put(deleteCompetenceGeneriqueFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setCompetencesGeneriquesLoading(false));
    }
}
